import axios from "axios";
import router from "@/router";
import { ElMessage } from 'element-plus';
                   
let baseURL = 'https://web.galaxyera.vip/'  //生产环境
if(window.location.href.includes('localhost') || window.location.href.includes('192.168.')){
	baseURL = '/api'  //测试环境
}     

const http = axios.create({
    baseURL,
    timeout: 10000,
    headers: { 
        "Content-Type": "application/json",
    },
})

//请求拦截器
http.interceptors.request.use( config => {
    if(config.url.includes('/admin') || config.url.includes('/stat/statistics')){
        const token = localStorage.getItem("token") || null
        if(token){
            config.headers.Authorization = 'Bearer ' + token;
        }
    }
    if(config.url.includes('/contract/upload')){
        config.headers["Content-Type"] = "multipart/form-data"
    }
    if (config.url.includes('/preview')) {
        //后端传的文件流返回要blob
        config.responseType = 'blob';
    }

    return config
}, error => {
    // return Promise.reject(error);
})

//响应拦截器
http.interceptors.response.use( response => {
    return response.data
    // let d = response.data
    // if(d.code==200 || response.config.url=='/bill/pay_status'){
    //     return d 
    // } else {
    //     if (d.msg) {
    //         ElMessage.error(d.msg) 
    //     }
    // }
    
}, error => {
    let e = error.response.data
    if(e.code == 401 && e.msg=='无效的认证凭证'){
        ElMessage.error('登录凭证已失效');
        localStorage.removeItem('token')
        router.replace('/login')
    }else if(e.code == 400){
        if(e.data && e.data.errors && e.data.errors.length>0 ) {
            let msg = e.data.errors[0].message
            ElMessage({
                type: 'error',
                message: msg,
                duration: 6000
            })
        } else if(e.msg){
            ElMessage({
                type: 'error',
                message: e.msg,
                duration: 6000
            })
        }
    }else if(error.config.responseType=='blob' && error.status==404) {
        ElMessage({
            type: 'error',
            message: '文件不存在',
            duration: 6000
        })
    }else {
        ElMessage({
            type: 'error',
            message: e.msg,
            duration: 6000
        })
    }
    
    // return Promise.reject(error);
})

export default http